var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 52.966,
    y: 201.776,
    style: {
      fill: "#707487"
    },
    width: 406.069,
    height: 247.172
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M494.345,466.607H17.655c-4.875,0-8.828-3.953-8.828-8.828v-8.828c0-4.875,3.953-8.828,8.828-8.828 h476.69c4.875,0,8.828,3.953,8.828,8.828v8.828C503.172,462.655,499.22,466.607,494.345,466.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M494.345,210.607H17.655c-4.875,0-8.828-3.953-8.828-8.828v-8.828c0-4.875,3.953-8.828,8.828-8.828 h476.69c4.875,0,8.828,3.953,8.828,8.828v8.828C503.172,206.655,499.22,210.607,494.345,210.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M503.172,484.262H8.828c-4.875,0-8.828-3.953-8.828-8.828v-8.828c0-4.875,3.953-8.828,8.828-8.828 h494.345c4.875,0,8.828,3.953,8.828,8.828v8.828C512,480.31,508.047,484.262,503.172,484.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M503.172,192.952H8.828c-4.875,0-8.828-3.953-8.828-8.828v-12.444c0-3.215,1.748-6.176,4.563-7.73 L247.471,29.934c5.309-2.929,11.748-2.929,17.057,0l242.908,134.018c2.815,1.554,4.563,4.514,4.563,7.73v12.444 C512,188.999,508.047,192.952,503.172,192.952z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M61.793,228.262h-35.31c-4.875,0-8.828-3.953-8.828-8.828v-8.828h52.966v8.828 C70.621,224.31,66.668,228.262,61.793,228.262z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.483,
    y: 228.259,
    style: {
      fill: "#AFB9D2"
    },
    width: 35.31,
    height: 211.862
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M26.483,422.469h35.31c4.875,0,8.828,3.953,8.828,8.828v8.828H17.655v-8.828 C17.655,426.422,21.608,422.469,26.483,422.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M273.655,228.262h-35.31c-4.875,0-8.828-3.953-8.828-8.828v-8.828h52.966v8.828 C282.483,224.31,278.53,228.262,273.655,228.262z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 238.345,
    y: 228.259,
    style: {
      fill: "#AFB9D2"
    },
    width: 35.31,
    height: 211.862
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M238.345,422.469h35.31c4.875,0,8.828,3.953,8.828,8.828v8.828h-52.966v-8.828 C229.517,426.422,233.47,422.469,238.345,422.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M203.034,228.262h-35.31c-4.875,0-8.828-3.953-8.828-8.828v-8.828h52.966v8.828 C211.862,224.31,207.91,228.262,203.034,228.262z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.724,
    y: 228.259,
    style: {
      fill: "#AFB9D2"
    },
    width: 35.31,
    height: 211.862
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M167.724,422.469h35.31c4.875,0,8.828,3.953,8.828,8.828v8.828h-52.966v-8.828 C158.897,426.422,162.849,422.469,167.724,422.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M132.414,228.262h-35.31c-4.875,0-8.828-3.953-8.828-8.828v-8.828h52.966v8.828 C141.241,224.31,137.289,228.262,132.414,228.262z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.103,
    y: 228.259,
    style: {
      fill: "#AFB9D2"
    },
    width: 35.31,
    height: 211.862
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M97.103,422.469h35.31c4.875,0,8.828,3.953,8.828,8.828v8.828H88.276v-8.828 C88.276,426.422,92.228,422.469,97.103,422.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M344.276,228.262h-35.31c-4.875,0-8.828-3.953-8.828-8.828v-8.828h52.966v8.828 C353.103,224.31,349.151,228.262,344.276,228.262z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 308.966,
    y: 228.259,
    style: {
      fill: "#AFB9D2"
    },
    width: 35.31,
    height: 211.862
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M308.966,422.469h35.31c4.875,0,8.828,3.953,8.828,8.828v8.828h-52.966v-8.828 C300.138,426.422,304.09,422.469,308.966,422.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M485.517,228.262h-35.31c-4.875,0-8.828-3.953-8.828-8.828v-8.828h52.966v8.828 C494.345,224.31,490.392,228.262,485.517,228.262z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 450.207,
    y: 228.259,
    style: {
      fill: "#AFB9D2"
    },
    width: 35.31,
    height: 211.862
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M450.207,422.469h35.31c4.875,0,8.828,3.953,8.828,8.828v8.828h-52.966v-8.828 C441.379,426.422,445.332,422.469,450.207,422.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M414.897,228.262h-35.31c-4.875,0-8.828-3.953-8.828-8.828v-8.828h52.966v8.828 C423.724,224.31,419.772,228.262,414.897,228.262z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.586,
    y: 228.259,
    style: {
      fill: "#AFB9D2"
    },
    width: 35.31,
    height: 211.862
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M379.586,422.469h35.31c4.875,0,8.828,3.953,8.828,8.828v8.828h-52.966v-8.828 C370.759,426.422,374.711,422.469,379.586,422.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M256,55.474l201.178,110.995H54.822L256,55.474"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M326.621,148.814H185.379c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 h141.241c4.875,0,8.828,3.953,8.828,8.828l0,0C335.448,144.862,331.496,148.814,326.621,148.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F96AC"
    },
    d: "M282.483,122.331h-52.966c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 h52.966c4.875,0,8.828,3.953,8.828,8.828l0,0C291.31,118.379,287.358,122.331,282.483,122.331z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtHistoryIcon);
export default __webpack_public_path__ + "static/media/art_history_icon.4d87f470c65b2f23e48340f86cfb6cb3.svg";
export { ForwardRef as ReactComponent };